import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Profil_ja from '../pages/profil-ja';
import ToPaySection from './pay/to_pay';
import Pulpit from './pulpit/pulpit';
import Wybor_opcji_4_forma_platnosci from '../pages/wybor-opcji-4-forma-platnosci';
import StudentCard from './studentCard/studentCard';
import EDSFooter from '../components/EDSFooter';
import Menu from './menu/menu';
import PaymentHistory from './pay/pastPaymant';
import CustomerService from '../pages/customerService/customerService';
import Header from './Elements/header/header';
import ApiService from '../services/ApiService';
import FAQ from '../pages/Faq/faq';
import Maps from '../pages/maps/maps';
import Setting from '../pages/Setting/setting';
import Calendar from './calendar/calendar';
import Courses from './forYou/courses';
import Events from './forYou/events';
import Workshops from './forYou/workshops';
import Departures from './forYou/departures';
import CustomRedText from './Elements/redText/redText';
import Modal from './Elements/modal/modal';
import CustomButtons from './Elements/Buttons/customButton';
const ContentWrapper = () => {
    const apiService = ApiService.getInstance();
    const location = useLocation();
    const [page, setPage] = useState(0);
    //routingChange
    // const [navigationState, setNavigation] = useState(window.location.href.split('#')[1]);
    const [navigationState, setNavigation] = useState(window.location.href);
    let [modalClass, showModal] = useState('modal hidden');
    let [modalClassII, showModalII] = useState('modal hidden');
    const [header, setHeader] = useState('');
    const [user, setUser] = useState();
    const [userID, setUserID] = useState();
    const [userName, setUserName] = useState();
    const [currentDate, setCurrentDate] = useState(new Date());
    const [isSettingLowlevel, setSettingLowlevel] = useState(false);
    const [side, setSide] = useState(0);
    const [msg, setMsg] = useState({
        msg:"",
        title:""
    })
    useEffect(() => {
        setPage(0);
        if (location.pathname === '/page2') setPage(1);
        if (location.pathname === '/page3') setPage(2);
    }, [location]);
const navigationStateII = window.location.href
    useEffect(() => {
        apiService.apiGet('UserGet', (response) => {
       
            if (response.success) {
                setUserID(response.data.usersID);
                setUser(response.data);
                setUserName(response.data.firstName + ' ' + response.data.lastName);
            } else {
            }
        });
    }, []);
    function logoutModal() {
        showModal('modal');
    }
    console.log(msg)
    function changeModal() {
        if (modalClassII == 'modal hidden') {
            showModalII('modal');
        } else {
            showModalII('modal hidden');
        }
    }
    function navigationRout() {

        if (navigationStateII.includes('/To_pay')) {
            return <ToPaySection setMsg={setMsg} modalClass={modalClassII} showModal={showModalII} setHeader={setHeader} userName={userName} userID={userID} />;
        }
        //routingChange
        // if (navigationState == '/Payment_history') {
        if (navigationStateII.includes('/Payment_history')) {       
            return <PaymentHistory setHeader={setHeader} userName={userName} userID={userID} />;
        }
        //routingChange
        //if (navigationState == '/Pulpit') {
        if (navigationStateII.includes('/Pulpit')) { 
                return <Pulpit setMsg={setMsg} modalClass={modalClassII} showModal={showModalII} setHeader={setHeader} userName={userName} userID={userID} />;
        }
        //routingChange
        //if (navigationState == '/Current_classes') {
        if (navigationStateII.includes('/Current_classes')) {
            return <Calendar user={user} localization={navigationStateII} value={currentDate} onChange={setCurrentDate} setHeader={setHeader} />;
        }
        //routingChange
//        if (navigationState == '/Todo_classes') {
        if (navigationStateII.includes('/Todo_classes')) {        
            return (
                <Calendar
                    user={user}
                    value={currentDate}
                    onChange={setCurrentDate}
                    filter={true}
                    setHeader={setHeader}
                    localization={navigationStateII}
                />
            );
        }
//routingChange
//        if (navigationState == '/Student_card') {
        if (navigationStateII.includes('/Student_card')) {
            return <StudentCard user={user} userID={userID} setHeader={setHeader} />;
        }
        //routingChange
//        if (navigationState == '/Customer_service') {
        if (navigationStateII.includes('/Customer_service') ) {    
            return <CustomerService setHeader={setHeader} />;
        }
        //routingChange
       // if (navigationState == '/Next_invoice') {
        if (navigationStateII.includes('/Next_invoice') ) {
            return <Wybor_opcji_4_forma_platnosci />;
        }
        //routingChange
       // if (navigationState == '/FAQ') {
        if (navigationStateII.includes('/FAQ')) {
            return <FAQ setHeader={setHeader} />;
        }
        //routingChange
       // if (navigationState == '/Maps') {
        if (navigationStateII.includes('/Maps') ) {
            return <Maps setHeader={setHeader} />;
        }
        if (navigationStateII.includes('/Setting')) {
            return <Setting side={side} setSide={setSide} userData={user} setHeader={setHeader}  userID={userID} />;
        }
        //routingChange
       // if (navigationState == '/Courses') {
        if (navigationStateII.includes('/Courses') ) {
            return <Courses userData={user} setHeader={setHeader} />;
        }
        //routingChange
      //  if (navigationState == '/Events') {
        if (navigationStateII.includes('/Events') ) {
            return <Events userData={user} setHeader={setHeader} />;
        }
        //routingChange
//if (navigationState == '/Workshops') {
        if (navigationStateII.includes('/Workshops') ) {
            return <Workshops userData={user} setHeader={setHeader} />;
        }
        //routingChange
        //if (navigationState == '/Departures') {
        if (navigationStateII.includes('/Departures')) {
            return <Departures userData={user} setHeader={setHeader} />;
        }
    }
    useEffect(()=>{
        setSide(0)
    },[navigationStateII])
    return (
        <>
            <div className={modalClassII}>
                <Modal close={changeModal}>
                    <div className='paymentPasswordSuccessMsg_area'>
                        <CustomRedText>{msg.title}</CustomRedText>
                        <div className='msg_area'>
                        <p className='msg msgIn'>{msg.msg}</p>
                        
                        </div>
                    
                     </div>
                </Modal>
            </div>
        {/* routingChange */}
            <Header setSide={setSide} isPulpit={true} side={side} nav={navigationState} setNav={setNavigation} modalClass={modalClass} showModal={showModal} >{header}</Header>
            {/* <Header isPulpit={true} >{header}</Header> */}
            <div className="content">
              
            <div className="dashboard">
                <div className="dashboard__main-box">
                    <Menu nav={navigationState} setNav={setNavigation} />
                    {navigationRout()}
                </div>
                <div className="margin-bottom-64"></div>
            </div></div>
            
            
        </>
    );
};

export default ContentWrapper;
